import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {UserService} from "../../../../core/user/user.service";
import {DashboardService} from "../../../../core/services/dashboard/dashboard.service";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {UTILS} from "../../../../core/const/const";
import {Router} from "@angular/router";

@Component({
  selector: 'app-modal-delete-visite',
  templateUrl: './modal-delete-visite.component.html',
  styleUrls: ['./modal-delete-visite.component.scss']
})
export class ModalDeleteVisiteComponent implements OnInit {
  @Input() visiteId: any;
  userConnected?: any = {};
  @Output() saveOrUpdate = new EventEmitter<any>();

  constructor(
    private modalService: NgbModal,
    private router: Router,
    private userService: UserService,
    private dashboardService: DashboardService
  ) {
  }

  ngOnInit(): void {
    this.userConnected = this.userService.getUser();
  }

  onCancelVisit(id: any) {
    this.dashboardService.cancelVisit(id).subscribe((response: any) => {
      setTimeout(() => {
        this.modalService.dismissAll();
        this.saveOrUpdate.emit()
        // console.log(this.router.url);
        // this.router.navigate([this.router.url], {onSameUrlNavigation: 'reload'});
        // this.router.navigateByUrl('/RefreshComponent', {skipLocationChange: true}).then(() => {
        //   this.router.navigate([this.router.url]);
        // });
      }, 200);
    });
  }

  openConfirmation(content: any) {
    this.modalService.dismissAll();
    this.modalService.open(content);
  }

}
